import { createMemo } from "solid-js"
import { useI18n } from "../i18n"

export const getFixtureSlot = (startDate: any, startTime: any) => {
    const { getI18n } = useI18n()
    const formattedDate = startDate.toLocaleDateString('en-GB', {
        day: '2-digit', 
        month: '2-digit'
    })

    const gameStartDate = startDate
        ? formattedDate
        : ''
        
    const gameStartTime = startTime
        ? getI18n()?.formatDate(startDate, {
            hour: '2-digit',
            minute: '2-digit',
            hour12: true,
        })
        : ''

    const memoizedSecondLine = createMemo(
        () => (gameStartTime ? `${gameStartDate} - ${gameStartTime}` : `${gameStartDate}`),
        [gameStartDate, gameStartTime],
    )

    return memoizedSecondLine()
}